import react, { useEffect, useLayoutEffect, useReducer } from 'react'
import { lockedReducer } from '../../../utils/defaultReducer'
import { Box, List, Button } from '@mui/material'
import api from '../../../api'
import HistoricRow from './historic_row'
import { getSession } from '../../../auth'
import dayjs from 'dayjs'
import EditList from '../../Scout/Pages/EditList'
import { useHistory } from "react-router-dom"
import { useLocation } from "react-router-dom"
import { moveToOpportunity } from './historic_component'

const LoadMore = async (contact, rows, cursor, setParent) => {
    setParent({ loading: true })
    const res = await api.get(`/api/enterprises/${contact.enterprise}/contacts/${contact.id}/opportunities/?cursor=${cursor}`)
    const newstate = { loading: false }
    if (res.status === 200) {
        const [newrows, newcursor] = res.data
        newstate.opportunities = [[...rows, ...newrows], newcursor]
    }
    setParent(newstate)
}

const HistoricOpportunities = ({ contact, data, setParent }) => {

    const history = useHistory()
    const location = useLocation()

    const [state, setState] = useReducer(lockedReducer, {
        activeDialog: null,
        editList: null
    })

    const [rows, cursor] = data

    const mergedRows = [...rows.map(row => {
        const return_row = {...row, timestamp: dayjs(`${row.date}T${row.time}`).unix()}
            if (return_row.platform_entrypoint === 'OPPORTUNITY')
                return ({...return_row, viewopportunity: ()=>{
                    moveToOpportunity(return_row.journey_id, return_row.id, history, location)
                }})
            return return_row
        })].toSorted((a, b) => b.timestamp - a.timestamp)

    return (
        <Box>
            {state.editList && <EditList data={state.editList} handleClose={()=> setState({editList: null})}/>}
            {state.activeDialog}
            <List className='historic-list-gap'>
                {mergedRows.map(row => (
                    <HistoricRow key={`historic-unique-row-${row.id}`} data={row} contact={contact} setParent={setState}/>
                ))}
            </List>
            {(data[0].length > 0 && cursor !== -1) &&
                <Box className='historic-show-more'>
                    <Button onClick={() => LoadMore(contact, rows, cursor, setParent)}>Mostrar mais</Button>
                </Box>
            }
        </Box>
    )
}

export default HistoricOpportunities